import { LoyaltyColors } from '@gamiphy/bl/loyaltyPage';
import { FontFamily, Fonts } from '@gamiphy/bl/font';
import type { Theme } from '@mui/material/styles/createTheme';
import React from 'react';
import { createTheme } from '@mui/material/styles';

export const useLoyaltyPageTheme = (loyaltyPageColors: LoyaltyColors, font: Fonts, muiTheme?: Theme): Theme => React.useMemo(() => createTheme({
  ...muiTheme,
  palette: {
    ...muiTheme?.palette,
    primary: {
      main: loyaltyPageColors?.primaryColor || muiTheme?.palette.primary.main || '#1a191c',
    },
    text: {
      primary: loyaltyPageColors?.mainFontColor || muiTheme?.palette.text.primary,
    },
    background: {
      ...muiTheme?.palette.background,
      paper: loyaltyPageColors?.backgroundColor || muiTheme?.palette.background.paper,
    },
  },
  typography: {
    ...muiTheme?.typography,
    fontFamily: FontFamily[font] || muiTheme?.typography.fontFamily,
    h1: {
      fontSize: '3.2rem',
      fontWeight: 700,
      lineHeight: '4rem',
      '@media (max-width:600px)': {
        fontSize: '2.4rem',
        lineHeight: '2.6rem',
      },
    },

    subtitle2: {
      fontSize: '2.4rem',
      lineHeight: '3.2rem',
      fontWeight: 400,
      '@media (max-width:600px)': {
        fontSize: '1.4rem',
        lineHeight: '1.6rem',
        fontWeight: 500,
      },
    },
    subtitle1: {
      fontSize: '2.4rem',
      lineHeight: '3.2rem',
      fontWeight: 400,
      '@media (max-width:600px)': {
        fontSize: '1.4rem',
        lineHeight: '1.6rem',
        fontWeight: 500,
      },
    },
    body1: {
      fontSize: '1.8rem',
      lineHeight: '2.52rem',
      fontWeight: 400,
      '@media (max-width:600px)': {
        fontSize: '1.4rem',
        lineHeight: '1.96rem',
      },
    },
    body2: {
      fontSize: '1.6rem',
      lineHeight: '2.4rem',
      fontWeight: 400,
      '@media (max-width:600px)': {
        fontSize: '1.4rem',
        lineHeight: '1.96rem',
      },
    },
    caption: {
      fontSize: '2.4rem',
      lineHeight: '3.2rem',
      fontWeight: 700,
      '@media (max-width:600px)': {
        fontSize: '2.1rem',
        lineHeight: '2.5rem',
        fontWeight: 700,
      },
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
        },
        containedPrimary: {
          fontFamily: FontFamily[font] || muiTheme?.typography.fontFamily,
          color: loyaltyPageColors?.buttonTextColor,
          backgroundColor: loyaltyPageColors?.primaryColor,
          '&:hover': {
            color: loyaltyPageColors?.buttonTextColor,
            backgroundColor: loyaltyPageColors?.primaryColor,
          },
        },
        outlinedPrimary: {
          fontFamily: FontFamily[font] || muiTheme?.typography.fontFamily,
          color: loyaltyPageColors?.buttonTextColor,
          borderColor: loyaltyPageColors?.buttonTextColor,
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent',
            color: loyaltyPageColors?.buttonTextColor,
            borderColor: loyaltyPageColors?.buttonTextColor,
          },
        },
      },
    },
  },

}), [
  loyaltyPageColors?.promoteWelcomeGiftTextColor,
  loyaltyPageColors?.mainFontColor,
  loyaltyPageColors?.heroSectionTextColor,
  loyaltyPageColors?.backgroundColor,
  loyaltyPageColors?.primaryColor,
  loyaltyPageColors?.buttonTextColor,
  font,
  muiTheme,
]);
